export enum DialogResult { 
    Cancelled =  "Cancelled", 
    Success = "Success", 
    Back = "Back" 
}
